"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addZero = void 0;
const addZero = (value) => `${value < 10 ? '0' : ''}${value}`;
exports.addZero = addZero;
//# sourceMappingURL=addZero.js.map